import Axios from "./CallerService"
export const getUser = (id) => {
    return Axios.get(`users/${id}`)
}